import React from "react";
import { useSelector } from "react-redux";

// will display elements of a single activity type
export default function ActivityType({ icon, name }) {
  const { videoActivityActive } = useSelector((state) => state.activityCategories);

  return (
    <div className="d-flex flex-column align-items-center activity_type">
      <img src={icon} className="activity_type-icon" />
      <p className="activity_name mt-3">{name}</p>
    </div>
  );
}
